import React from "react";

interface Props {
    active: boolean;
    onClick: () => void;
}

export const MobileNavigationButton = (props: Props) => {
    const lineBaseClass = "absolute top-1/2 right-0 mr-3 w-5 h-px-2 bg-brand-primary-20 transform transition duration-300";

    return (
        <button
            type="button"
            className={`relative inline-flex items-center justify-between pl-2 pr-10 h-full
                border-t border-r border-l
                cursor-pointer focus:outline-none
                ${props.active ? "bg-brand-primary-100 border-brand-primary-95" : "bg-transparent border-transparent"}`}
            onClick={props.onClick}
        >
            <span className="text-xs mr-1 uppercase font-bold align-middle">Menu</span>
            <span className={`${lineBaseClass} ${props.active ? "rotate-45" : "-mt-1 -translate-y-1/2"}`} aria-hidden></span>
            <span className={`${lineBaseClass} ${props.active ? "-rotate-45" : "mt-1 -translate-y-1/2"}`} aria-hidden></span>
        </button>
    );
};